import EnumType from "../../../../models/EnumType";

type BusinessType = TestRequestRaw.Schemas.BusinessType;
type ReportUsage = TestRequestRaw.Schemas.ReportUsage;
type StringDictionary<T extends string> = {
  [K in EnumType<T>]: string;
};

export const BUSINESS_TYPE: StringDictionary<BusinessType> = {
  BASIC_ANALYSIS: "BasicsAnalysis",
  MAINTAIN: "Replacement",
  NEW: "Incremental",
  "": "",
};

export const REPORT_USAGE: StringDictionary<ReportUsage> = {
  EXTERNAL: "External",
  ONLY_INTERNAL: "Internal",
  "": "",
};
